/**
 * VisionARVisionPageView
 *
 * Page component for VisionARVisionPageView
 * Path: /ar/vision
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { VisionARVisionPageView as __VisionARVisionPageView } from '@/components/traits/VisionARVisionPageView';
import { VisionARVisionAnalyticsView as __VisionARVisionAnalyticsView } from '@/components/traits/VisionARVisionAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface VisionARVisionPageViewProps {
  // Add any page-level props here
}

export function VisionARVisionPageView(_props: VisionARVisionPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-vision:meta.title"],"description":["i18n/t","std-almadar-vision:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/vision"},{"locale":"ar","path":"/ar/vision"},{"locale":"sl","path":"/sl/vision"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__VisionARVisionPageView config={{ initPayload: __navState }} />
          <__VisionARVisionAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default VisionARVisionPageView;
